export enum Endpoints {
    SEND_PROFESIONALS = 'profesional/contact',
    SEND_CONSULT = 'profesional/asesor',
}